import { AttributeType } from 'data/types';

export const REQUIRED_SPACE_ATTRIBUTE_CODES = [
  'heating',
  'cooling',
  'square_footage',
  'ceiling_type',
  'ceiling_height',
  'space_above',
  'space_below'
] as const;

export type RequiredSpaceAttributeCode =
  (typeof REQUIRED_SPACE_ATTRIBUTE_CODES)[number];

export function isRequiredSpaceAttributeCode(
  code: string
): code is RequiredSpaceAttributeCode {
  return (REQUIRED_SPACE_ATTRIBUTE_CODES as readonly string[]).includes(code);
}

export function isSpaceItemGroup(group: string | null | undefined): boolean {
  return group === 'Space';
}

export function isLockedSpaceAttributeAssignment(
  code: string,
  lockRequired: boolean
): boolean {
  return lockRequired && isRequiredSpaceAttributeCode(code);
}

export function getRequiredSpaceAttributes(
  allAttributes: AttributeType[]
): AttributeType[] {
  return allAttributes
    .filter((attribute) => isRequiredSpaceAttributeCode(attribute.code))
    .map((attribute) => ({ ...attribute, required: false }));
}

export function withRequiredSpaceAttributes(
  assigned: AttributeType[],
  allAttributes: AttributeType[]
): AttributeType[] {
  const requiredAttributes = getRequiredSpaceAttributes(allAttributes);
  const missingAttributes = requiredAttributes.filter(
    (requiredAttribute) =>
      !assigned.some((attribute) => attribute.id === requiredAttribute.id)
  );
  return [...assigned, ...missingAttributes];
}
